import { usePrinter } from '../../hooks/usePrinter'
import * as routes from '../../routes'

import PrintSettingsUI from './View'
import Download from './Download'
import Form from './Form'

const PrintSettings = () => {
  const {
    MODEL_TYPES,
    PRINT_TYPES,
    isWorking,
    printers,
    printer,
    modelType,
    printType,
    printPosition,
    loadPrinters,
    updatePrinter,
    updateModelType,
    updatePrintType,
    updatePrintPosition,
  } = usePrinter()

  return (
    <PrintSettingsUI>
      {!isWorking ? (
        <Download downloadUrl={routes.DOWNLOADS.path} />
      ) : (
        <Form
          printers={printers}
          modelTypes={MODEL_TYPES}
          printTypes={PRINT_TYPES}
          initialValues={{ printer, modelType, printType, printPosition }}
          onReloadPrinters={loadPrinters}
          onPrinterChange={updatePrinter}
          onModelTypeChange={updateModelType}
          onPrintTypeChange={updatePrintType}
          onPrintPositionChange={updatePrintPosition}
        />
      )}
    </PrintSettingsUI>
  )
}

export default PrintSettings
